import * as React from 'react';
import { ButtonType, CustomButton, CustomSubmitButton, Table } from "soprasteria-ui-library";
import { IOrthodonticReferral, IOrthodonticReferralPatientViewing } from '../../../../models/IOrthodonticReferral';
import { dateTimeToDateString } from '../../../../helpers/DateHelper';
import "./OrthodonticReferralPatientViewingTable.scss";

interface IOrthodonticReferralPatientViewingTable {
    orthodonticReferral: IOrthodonticReferral;
    openOrthodonticReferralPatientViewingModal: (orthodonticReferralPatientViewingId: number) => void
}

export const OrthodonticReferralPatientViewingTable: React.FunctionComponent<IOrthodonticReferralPatientViewingTable> = ({ orthodonticReferral, openOrthodonticReferralPatientViewingModal }) => {

    const renderClickableColumn = (patientViewing: IOrthodonticReferralPatientViewing, text: string, showButton: boolean) => {
        return (
            <td className={showButton ? "custome-row" : ""}>{text}
                {
                    showButton &&
                        <button type="button" className="btn btn-sm btn-primary" onClick={() => openOrthodonticReferralPatientViewingModal(patientViewing.orthodonticReferralPatientViewingId)}>
                            Markera patient som kallad till visning
                        </button>
                }
            </td>
        )
    }

    const anythingToEdit = (patientViewings: IOrthodonticReferralPatientViewing[]) => {
        return patientViewings.some(data => data.canEdit == true);
    }

    return (
        <Table hoverableRows={orthodonticReferral.patientViewings && anythingToEdit(orthodonticReferral.patientViewings)}>
            <thead>
                <tr>
                    <th>Datum för begäran</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {
                    orthodonticReferral.patientViewings && orthodonticReferral.patientViewings.length > 0 ?
                        orthodonticReferral.patientViewings.map((patientViewing, key) =>
                            <tr key={key}>
                                {renderClickableColumn(patientViewing, dateTimeToDateString(patientViewing.regDate), false)}
                                {renderClickableColumn(patientViewing, patientViewing.status, patientViewing.canEdit && patientViewing.status == "Inväntar kallelse")}
                            </tr>
                        )
                        : <tr><td colSpan={2}>Ingen visning av patient är begärd</td></tr>
                }
            </tbody>
        </Table>
    )
}